export default "<router-outlet></router-outlet>\n<cc-block-ui></cc-block-ui>"